import { ReactNode } from "react";
import { LocalizationOverride } from "./types";
import { LocalizationProvider } from "@amzn/aws-tc-xb-xps";

export const LocalizationOverrideProvider = ({
  children,
  override,
}: {
  children: ReactNode;
  override?: LocalizationOverride;
}) => {
  return override !== undefined ? (
    <LocalizationProvider {...override}>{children}</LocalizationProvider>
  ) : (
    <>{children}</>
  );
};
